<template>
  <div></div>
</template>

<script>
import { CameraMove } from "@/assets/js/unity3D/index.js";
export default {
  data() {
    return {
      cameraPosList: [
        {
          latitude: 39.493926378789965,
          longitude: 118.27945331938264,
          xDeg: -60.4060822,
          yDeg: 29.8999958,
          distance: 793.5946,
        },
        {
          latitude: 39.504446577178605,
          longitude: 118.27615508808688,
          xDeg: -141.3061,
          yDeg: 22.0999947,
          distance: 793.5946,
        },
        {
          latitude: 39.5039748398018,
          longitude: 118.26903128566956,
          xDeg: -223.406082,
          yDeg: 18.2999973,
          distance: 793.5946,
        },
        {
          latitude: 39.497076326941041,
          longitude: 118.26989966044911,
          xDeg: -332.4061,
          yDeg: 23.8999977,
          distance: 793.5946,
        },
      ],
      nowIndex: 0,
    };
  },
  mounted() {
    this.getRoundCamera();
  },
  unmounted() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    getRoundCamera() {
      // this.clearTimer();
      if (this.nowIndex >= this.cameraPosList.length) {
        this.nowIndex = 0;
      }
      CameraMove(this.cameraPosList[this.nowIndex]);
      this.nowIndex += 1;
      this.timer = setTimeout(() => {
        this.getRoundCamera();
      }, 30 * 1000);
    },
  },
};
</script>

<style>
</style>